import { memo } from 'react';

import { Fields } from '@air/next-icons';
import { HoverCard } from '@air/primitive-hover-card';

import { CardAction } from '~/components/CardAction';
import { CustomFieldsDisplay } from '~/components/Gallery/CustomFieldsDisplay';
import { type AssignedCustomFieldValue } from '~/swr-hooks/customFields/types';

export type GalleryBoardCustomFieldActionProps = {
  customFields: AssignedCustomFieldValue[];
  onClick?: () => void;
};

export const GalleryBoardCustomFieldAction = memo(({ customFields, onClick }: GalleryBoardCustomFieldActionProps) => {
  return (
    <HoverCard
      openDelay={0}
      align="start"
      trigger={
        <CardAction data-testid="CUSTOM_FIELDS_INDICATOR" icon={<Fields className="size-4" />} onClick={onClick} />
      }
    >
      <CustomFieldsDisplay
        onClick={onClick}
        style={{ minWidth: 250, maxWidth: 400 }}
        customFields={customFields}
        shouldShowLabelInline
      />
    </HoverCard>
  );
});

GalleryBoardCustomFieldAction.displayName = 'GalleryBoardCustomFieldAction';
